<template>
  <div
    v-if="season === 'H' && (descriptionText && descriptionText?.length > 2)"
    class="col-12 pt-0 py-md-5"
  >
    <!-- Desktop -->
    <div class="d-none d-md-block justify-content-between">
      <h3 class="title-3 text-grey-900 pt-2 pb-4">
        {{ content.station_SkiArea }} {{ stationData.nameDomain }}
      </h3>
    </div>
    <!-- Mobile -->
    <a
      class="d-md-none w-100 border-top border-1 py-3 border-top py-3"
      data-toggle="collapse"
      type="button"
      data-target="#tf-info-domain-inner"
      aria-expanded="false"
      aria-controls="tf-info-domain-inner"
    >
      <div class="d-flex justify-content-between border-top border-gray py-2">
        <div class="title-3 text-grey-900 pt-2">
          {{ content.station_SkiArea }} {{ stationData.nameDomain }}
        </div>
        <div class="d-flex d-sm-none align-items-center text-light-blue">
          <svg color="black" width="13" height="13" viewBox="0 0 16 16" class="bi bi-chevron-up" fill="none">
            <use href="#___icon___chevron-up-bold"></use>
          </svg>
          <svg color="black" width="13" height="13" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="none">
            <use href="#___icon___chevron-down-bold"></use>
          </svg>
        </div>
      </div>
    </a>

    <div
      data-mobile-collapsed
      data-desktop-expanded
      v-if="season === 'H'"
      id="tf-info-domain-inner"
      class="collapse row"
    >
      <div
        v-if="descriptionText?.length > 2"
        class="col-12 col-lg-5"
      >
        <div
          id="domainDescription"
          ref="domainDescriptionWrap"
          class="bodytext-grey-900 pt-4 pb-3"
        >
          <div
            class="body text-grey-900 show-more-less-text mb-2"
            v-html="descriptionText"
          ></div>
          <div
            class="link-large-underline link-default read-more py-3 cursor-pointer"
          >
            <span>{{ content.station_seeMore }}</span>
            <span>
              <svg style="color: var(--primary-blue);" width="10" height="10">
                <use href="#___icon___chevron-right-bold"></use>
              </svg>
            </span>
          </div>
          <div
            class="link-large-underline link-default read-less cursor-pointer"
          >
            <span>
              <span class="pr-1">{{ content.station_seeLess }}</span>
              <svg style="color: var(--primary-blue);" width="10" height="16" viewBox="0 0 16 16" class="bi bi-chevron-up" fill="none">
                <use href="#___icon___chevron-up-bold"></use>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-7">
        <SkiAreaStats
          :pisteLength="stationData.pisteLength"
          :nbSlopes="stationData.nbSlopes"
          :nbSkiLifts="stationData.nbDomainSkiLifts"
          :data="data"
          :stationData="stationData"
          :content="content"
          :isConnectedDomain="false"
        />
        <SlopesInformation
          v-if="stationData.nbSlopesGreen"
          :nbSlopesGreen="stationData.nbSlopesGreen"
          :nbSlopesBlue="stationData.nbSlopesBlue"
          :nbSlopesRed="stationData.nbSlopesRed"
          :nbSlopesBlack="stationData.nbSlopesBlack"
          :domainName="stationData.nameDomain"
          :content="content"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess.js";
import SkiAreaStats from "./SkiAreaStats.vue";
import SlopesInformation from "./SlopesInformation.vue";

interface DomainSectionProps {
  data: Record<string, any>;
  stationData: Record<string, any>;
  descriptionText: string;
  season: string;
  content: Record<string, string>;
}

const props = defineProps<DomainSectionProps>();
const domainDescriptionWrap = ref<HTMLElement | null>(null);

const initializeTextShowMoreLess = () => {
  if (domainDescriptionWrap.value) {
    const textShowMoreLess = new TextShowMoreLess(domainDescriptionWrap.value, 15);
    textShowMoreLess.init();
  }
};

onMounted(() => {
  initializeTextShowMoreLess();
});
</script> 